import { getMeshRecommendationsApi } from 'api/meshRecommends';

export const getMeshRecommendations = async ({ module, instanceId }) => {
  const res = await getMeshRecommendationsApi({ module, instanceId });
  return res.entity;
};
